var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiveEstimator({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Budget_-_Free_real_estate_icons-2",
    "data-name": "Budget - Free real estate icons-2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10317",
    "data-name": "Group 10317",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9942",
    "data-name": "Path 9942",
    d: "M51.364,66.613H22.335a1.465,1.465,0,0,0,0,2.93H51.364a1.465,1.465,0,1,0,0-2.93Zm0,5.859H22.335a1.465,1.465,0,1,0,0,2.93H51.364a1.465,1.465,0,1,0,0-2.93ZM39.646,78.331H22.335a1.465,1.465,0,0,0,0,2.93H39.646a1.465,1.465,0,1,0,0-2.93ZM12.346,66.25H15.63a1.465,1.465,0,1,0,0-2.93H13.841V61.779a1.465,1.465,0,0,0-2.93,0v1.763a4.749,4.749,0,0,0,1.434,9.276,1.819,1.819,0,0,1,0,3.638H9.061a1.465,1.465,0,1,0,0,2.93h1.85v1.8a1.465,1.465,0,0,0,2.93,0V79.143a4.748,4.748,0,0,0-1.5-9.255,1.819,1.819,0,1,1,0-3.638Zm39.019-5.5H22.335a1.465,1.465,0,0,0,0,2.93H51.364a1.465,1.465,0,0,0,0-2.93Zm11.464,1.38A1.465,1.465,0,0,0,64.294,63.6h2.862V66.46a1.465,1.465,0,1,0,2.93,0V63.6h2.862a1.465,1.465,0,1,0,0-2.93H70.085V57.807a1.465,1.465,0,1,0-2.93,0v2.862H64.294A1.465,1.465,0,0,0,62.829,62.134ZM84.237,90.8H92.89a1.465,1.465,0,1,0,0-2.93H84.237a1.465,1.465,0,1,0,0,2.93Zm0-5.859H92.89a1.465,1.465,0,1,0,0-2.93H84.237a1.465,1.465,0,1,0,0,2.93ZM64.525,90.5a1.465,1.465,0,0,0,2.071,0l2.024-2.024L70.644,90.5a1.465,1.465,0,0,0,2.071-2.072L70.692,86.4l2.024-2.023a1.465,1.465,0,0,0-2.071-2.072L68.62,84.33,66.6,82.306a1.465,1.465,0,0,0-2.071,2.072L66.549,86.4l-2.024,2.023A1.465,1.465,0,0,0,64.525,90.5ZM92.676,48.535H70.049V7.324A7.332,7.332,0,0,0,62.725,0H15.9A1.479,1.479,0,0,0,14.86.429L.429,14.86A1.5,1.5,0,0,0,0,15.9V92.676A7.332,7.332,0,0,0,7.324,100H92.676A7.332,7.332,0,0,0,100,92.676V55.859A7.332,7.332,0,0,0,92.676,48.535ZM14.431,5V11.99a2.444,2.444,0,0,1-2.441,2.441H5ZM58.653,97.07H7.324A4.4,4.4,0,0,1,2.93,92.676V17.361h9.06a5.377,5.377,0,0,0,5.371-5.371V2.93H62.725a4.4,4.4,0,0,1,4.395,4.395V48.535H64.508a7.332,7.332,0,0,0-7.324,7.324V92.676A7.286,7.286,0,0,0,58.653,97.07Zm18.474,0H64.508a4.4,4.4,0,0,1-4.395-4.395V75.732H77.127Zm0-24.268H60.114V55.859a4.4,4.4,0,0,1,4.395-4.395H77.127ZM97.07,92.676a4.4,4.4,0,0,1-4.395,4.395H80.057V75.732H97.07Zm0-19.873H80.057V51.465H92.676a4.4,4.4,0,0,1,4.395,4.395ZM92.89,60.669H84.237a1.465,1.465,0,1,0,0,2.93H92.89a1.465,1.465,0,1,0,0-2.93Z",
    transform: "translate(0)",
    fill: "#286c4d"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10318",
    "data-name": "Group 10318",
    transform: "translate(20.869 8.727)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10303",
    "data-name": "Group 10303",
    transform: "translate(-3 5.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9935",
    "data-name": "Path 9935",
    d: "M137.992,59.527,122.714,45.174a1.827,1.827,0,0,0-2.5,0L104.934,59.526a1.827,1.827,0,1,0,2.5,2.664l14.027-13.177L135.49,62.19a1.827,1.827,0,1,0,2.5-2.663Z",
    transform: "translate(-104.358 -44.678)",
    fill: "#286c4d"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10319",
    "data-name": "Group 10319",
    transform: "translate(22.33 21.585)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10305",
    "data-name": "Group 10305"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9936",
    "data-name": "Path 9936",
    d: "M147.026,84.595l-9.352-8.786a3.026,3.026,0,0,0-4.136,0l-9.351,8.785a3.031,3.031,0,0,0-.953,2.2v12.78a3.024,3.024,0,0,0,3.021,3.021h18.7a3.024,3.024,0,0,0,3.021-3.021V86.8A3.032,3.032,0,0,0,147.026,84.595Zm-10.08,14.348h-2.68V92.608h2.68Zm7.378,0H140.6V91.451a2.5,2.5,0,0,0-2.5-2.5h-5a2.5,2.5,0,0,0-2.5,2.5v7.492h-3.724V87.07h0l8.718-8.19,8.718,8.19Z",
    transform: "translate(-123.234 -74.992)",
    fill: "#286c4d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiveEstimator);
export default __webpack_public_path__ + "static/media/giveEstimator.75aae044b06fccc001c37fc5e9728a66.svg";
export { ForwardRef as ReactComponent };